/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
export var Behavior;
(function (Behavior) {
    Behavior["INTERACTIVE_CHART"] = "INTERACTIVE_CHART";
    Behavior["NATIVE_FILTER"] = "NATIVE_FILTER";
})(Behavior || (Behavior = {}));
export var AppSection;
(function (AppSection) {
    AppSection["EXPLORE"] = "EXPLORE";
    AppSection["DASHBOARD"] = "DASHBOARD";
    AppSection["FILTER_BAR"] = "FILTER_BAR";
    AppSection["FILTER_CONFIG_MODAL"] = "FILTER_CONFIG_MODAL";
    AppSection["EMBEDDED"] = "EMBEDDED";
})(AppSection || (AppSection = {}));
export var ChartLabel;
(function (ChartLabel) {
    ChartLabel["DEPRECATED"] = "DEPRECATED";
    ChartLabel["FEATURED"] = "FEATURED";
})(ChartLabel || (ChartLabel = {}));
export const chartLabelExplanations = {
    [ChartLabel.DEPRECATED]: 'This chart uses features or modules which are no longer actively maintained. It will eventually be replaced or removed.',
    [ChartLabel.FEATURED]: 'This chart was tested and verified, so the overall experience should be stable.',
};
export const chartLabelWeight = {
    [ChartLabel.DEPRECATED]: {
        weight: -0.1,
    },
    [ChartLabel.FEATURED]: {
        weight: 0.1,
    },
};
export default {};
//# sourceMappingURL=Base.js.map